import React from 'react'
import Logo from '../logo'
import SideBarTab from '../sideBarTab'

const SideBar = () => {
  return (
    <div className="side-bar">
      <Logo />
      <div className="primary-side-bar-tabs">
        <div className="side-bar-tab">
          <SideBarTab active text="Minds" />
        </div>
        {/* <div className="side-bar-tab">
          <SideBarTab text="Folders" />
        </div>
        <div className="side-bar-tab">
          <SideBarTab text="Tags" />
        </div> */}
      </div>
      {/* <h3 className="block-title">Favorites</h3>
      <div className="favorite-side-bar-tabs">
        <div className="side-bar-tab">
          <SideBarTab text="1,000 days of freeCode Camp" />
        </div>
        <div className="side-bar-tab">
          <SideBarTab text="Design" />
        </div>
      </div> */}
      <style jsx>{`
        .side-bar {
          background-color: #f4f4f7;
          padding: 40px 32px;
          box-sizing: border-box;
          height: 100%;
        }
        .primary-side-bar-tabs {
          margin: 40px 0;
        }
        .side-bar-tab {
          height: 32px;
        }
        .block-title {
          color: #707070;
          font-size: 14px;
          margin: 0;
          margin-bottom: 8px;
          font-weight: normal;
        }
      `}</style>
    </div>
  )
}

export default SideBar



// WEBPACK FOOTER //
// ./src/components/sideBar/index.js